// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import contentModule css modules
import contentModuleStyles from '../contentModuleModuleStyles.css';
// not updating links here because this should no longer be used with athens handling training


const ContentModuleTableOfContentsItem = ({
  courseSlug
  , currentNodeId
  , hasValidCert
  , hideFollowUps
  , isConclusionPage
  , node
  , scenes
  , selectedContentModule
  , studySlug
  , visited
}) => {

  if(node.toc) {
    let selectedScene = _.filter(scenes, scene =>  scene._id === node._scene)[0];
    if(node._id === currentNodeId) {
      return (
        <div className="toc-link -current">
          {selectedScene ? selectedScene.title : 'n/a'}
          <i className="fas fa-arrow-right" />
        </div>
      )
    } else if(visited || isConclusionPage || hasValidCert) {
      return (
        <Link
          className="toc-link -visited"
          onClick={hideFollowUps}
          to={courseSlug && studySlug ? `/my-studies/${studySlug}/courses/${courseSlug}/cms/${selectedContentModule.slug}/node/${node._id}` : `/my-agenda/cms/${selectedContentModule.slug}/node/${node._id}`}
        >
          {selectedScene ? selectedScene.title : 'n/a'}
          <i className="fas fa-check-circle" />
        </Link>
      )
    } else {
      return (
        <span
          className="toc-link -not-allowed"
        >
          {selectedScene ? selectedScene.title : 'n/a'}
          <i className="far fa-circle" />
        </span>
      )
    }
  } else {
    return null
  }
}

ContentModuleTableOfContentsItem.propTypes = {
  courseSlug: PropTypes.string
  , currentNodeId: PropTypes.string
  , hasValidCert: PropTypes.bool
  , hideFollowUps: PropTypes.func
  , isConclusionPage: PropTypes.bool
  , node: PropTypes.object.isRequired
  , scenes: PropTypes.array.isRequired
  , selectedContentModule: PropTypes.object.isRequired
  , studySlug: PropTypes.string
  , visited: PropTypes.bool
}

ContentModuleTableOfContentsItem.defaultProps = {
  courseSlug: null
  , currentNodeId: ""
  , hasValidCert: false
  , hideFollowUps: null
  , isConclusionPage: false
  , studySlug: null
  , visited: false
}

export default ContentModuleTableOfContentsItem;



// WEBPACK FOOTER //
// modules/contentModule/components/ContentModuleTableOfContentsItem.js.jsx